import React from 'react';
import clsx from 'clsx';

import './index.scss';
import RequiredOrOptionalIcon from 'components/atoms/Icon/RequiredOrOptionalIcon';
import TextAreaInput from 'components/atoms/Input/TextAreaInput';
import PcErrorArea from 'components/molecules/PcErrorArea';
import PcPopUp from 'components/molecules/PcPopUp';

const PcFreeInputArea = ({
  visible,
  // textarea header
  title,
  label,
  questionMark,
  popUpTitle,
  popUpDetail,
  noArrow,
  relativePosArrow,
  // textarea
  name,
  textAreaValue,
  cmntOnChange,
  onInput,
  onCompositionEnd,
  maxLength,
  placeholder,
  rows,
  cols,
  // 文字数
  wordCount,
  //エラー
  errMessage,
}) =>{
  const DispTitle = () => {
    return (
      <span>
        { Array.isArray(title)
          ? title.map((line, index) => (
              <>{line}{(index != title.length - 1)? <br /> : <></>}</>
          ))
          : <>{title}</>}
      </span>
    );
  };

  const editPopUpDetail = (popUpLines) => {
    return (
      <span>
      <p>
        {Array.isArray(popUpLines)? popUpLines.map(line => (<>{line}<br /></>)) : <>{popUpLines}</>}
      </p>
    </span>
    );
  };

  return(
    <div className="PcFreeInputArea">
      <div className="pc-accordion-text-area-wrapper">
        <div className={clsx('pc-cmnt-area', { visible })}>
          <div className="arrowArea">
          {
            noArrow? <div className="pc-background-cmnt" style={{borderLeft: 'none',borderRight: 'none'}}/>:
              <div className="pc-background-cmnt" style={{marginLeft: relativePosArrow}}/>
          }
          </div>
          <div className="pcCollpseAreaBackground">
            <div>
              <DispTitle />
              {<RequiredOrOptionalIcon label={label} />}
              {questionMark && 
                <span>
                  <PcPopUp title={popUpTitle} children={editPopUpDetail(popUpDetail)}/>
                </span>
              }
            </div>
            <TextAreaInput
              name={name}
              value={textAreaValue}
              onChange={cmntOnChange}
              onInput={onInput}
              onCompositionEnd={onCompositionEnd}
              maxLength={maxLength}
              placeholder={placeholder}
              rows={rows}
              cols={cols}
            />
            <div className='word-count'>{wordCount}</div>
            <span className='errArea'>
              <PcErrorArea position='relative' message={errMessage} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PcFreeInputArea;